import { useState } from "react"

import { useTranslation } from "react-i18next"
import ReactMarkdown from "react-markdown"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Cookies } from "@/constants/cookies"
import styles from "@/features/chat/styles/answer.module.css"
import { cn } from "@/lib/utils"
import { cookieService } from "@/services/cookie-service"

type AgentModeInfoModalProps = {
  open: boolean
  onClose: () => void
}

export function AgentModeInfoModal({ open, onClose }: AgentModeInfoModalProps) {
  const { t } = useTranslation()
  const [dontShowAgain, setDontShowAgain] = useState(false)

  const handleConfirm = () => {
    if (dontShowAgain) {
      cookieService.set(Cookies.hideAgentModeInfo.key, "true")
    }
    onClose()
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("agent_mode.info.title")}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <div className={cn(styles.answerText, "prose dark:prose-invert")}>
            <ReactMarkdown>{t("agent_mode.info.description")}</ReactMarkdown>
          </div>
        </AlertDialogBody>
        <div className="flex flex-shrink-0 items-center space-x-2">
          <Checkbox
            checked={dontShowAgain}
            id="dont-show-agent-info-again"
            onCheckedChange={(checked) => setDontShowAgain(checked as boolean)}
          />
          <Label htmlFor="dont-show-agent-info-again">{t("pages.common.dont_show_again")}</Label>
        </div>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleConfirm}>{t("pages.common.ok")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
